<template> </template>

<script>
import store from '../../store';

export default {
    mounted: function() {
        store.dispatch('reLogin');
    }
};
</script>
